var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "row bg-white", attrs: { show: _vm.loading } },
    [
      _c("div", { staticClass: "col-12 mt-3" }, [
        _vm._v(
          " ¿Estás seguro de que quieres aprobar el Lote Nº " +
            _vm._s(_vm.batch.folio) +
            "? "
        )
      ]),
      _c(
        "div",
        { staticClass: "col-12 mt-3" },
        [
          _c(
            "b-form",
            { attrs: { id: "form-message", "data-vv-scope": "form-message" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Descripción del lote",
                            "label-for": "#"
                          }
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-textarea", {
                                attrs: {
                                  rows: "4",
                                  max: "",
                                  maxlength: "5000",
                                  "data-cy": "description",
                                  "data-vv-as": "Descripción",
                                  id: "description",
                                  name: "description",
                                  state: _vm.errors.has(
                                    "form-message.description"
                                  )
                                    ? false
                                    : null,
                                  placeholder: "Datos adicionales internos"
                                },
                                model: {
                                  value: _vm.description,
                                  callback: function($$v) {
                                    _vm.description = $$v
                                  },
                                  expression: "description"
                                }
                              }),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-message.description"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("vs-divider"),
      _c(
        "b-col",
        { staticClass: "text-right", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: {
                type: "submit",
                variant: "primary",
                "data-cy": "approve-batch"
              },
              on: { click: _vm.onApprove }
            },
            [_vm._v(" Si, Estoy seguro! ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }